import angular from 'angular';
import _, { pick } from 'lodash';
// import deleteModalTemplate from './catalog.delete.modal.html';
// import removeModalTemplate from './catalog.remove.modal.html';

class OrderAndPayPickupPointController {
  /* @ngInject */
  constructor($rootScope, $log, $timeout, $translate, ModalFactory, ProductsActions, ProductsStore, StoreStates, PickupPointService, StorageService, MerchantVasService) {
    const that = this;

    that.currentVasTypeId = MerchantVasService.getVasesTypes()['ORDER-AND-PAY'];

    that.loading = {
      pickupPoints: false
    };

    let pickupPoints = [];

    const loadPickupPoints = () => {
      this.loading.pickupPoints = true;

      PickupPointService.getPickupPoints(this.currentVas.id).then(
        (response) => {
          this.loading.pickupPoints = false;
          that.pickupPoints = response.data;
        },
        (error) => {
          this.loading.pickupPoints = false;
          console.log(error);
        }
      );
    };

    const init = () => {

      this.loading.pickupPoints = true;

      const merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            loadPickupPoints();
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    const closeModal = modal => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
      loadPickupPoints();
    };

    that.$onInit = init;


    that.deleteProduct = pickupPoint => {
      if(confirm('Sicuro di voler eliminare questo punto di ritiro?'))
      {
        PickupPointService.deletePickupPoint(pickupPoint).then((response) => {
          console.log(response);
          loadPickupPoints();
        })
      }
    };

    that.createPickupPoint = () => {
      console.log('createPickupPoint');
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: '<edit-pickup-point mode="create" on-cancel="cancel()" vas-id="vasId"></edit-pickup-point>',
        class: 'large',
        contentScope: {
          cancel: () => closeModal(modal),
          vasId: this.currentVas.id,
        }
      });

      modal.activate();
    };

    that.editPickupPoint = pickupPoint => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: '<edit-pickup-point mode="edit" on-cancel="cancel()" pickup-point="pickupPoint"></edit-pickup-point>',
        class: 'large',
        contentScope: {
          cancel: () => closeModal(modal),
          pickupPoint: angular.copy(pickupPoint),
        }
      });

      modal.activate();
    };


  }
}

export default OrderAndPayPickupPointController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/pickupPoint.controller.js
 **/